(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["symk-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Bind once globally — the card snippet may render many times per page.
    if (window.__symkCardWishlistBound) return;
    window.__symkCardWishlistBound = true;

    function buttons() {
      return document.querySelectorAll('[data-symk-wishlist-toggle]');
    }

    function sync() {
      if (!window.SymkWishlist) return;
      buttons().forEach(function (btn) {
        var saved = window.SymkWishlist.has(btn.getAttribute('data-handle'));
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
        btn.classList.toggle('is-saved', saved);
      });
    }

    document.addEventListener('click', function (e) {
      var target = e.target;
      var btn = target && target.closest ? target.closest('[data-symk-wishlist-toggle]') : null;
      if (!btn || !window.SymkWishlist) return;
      e.preventDefault();
      window.SymkWishlist.toggle({
        handle: btn.getAttribute('data-handle'),
        variantId: btn.getAttribute('data-variant') || null
      });
    });

    document.addEventListener('symk:wishlist:change', sync);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();

  (function () {
    // Add-to-cart, bound once globally — cards render many times per page.
    if (window.__symkCardCartBound) return;
    window.__symkCardCartBound = true;

    function updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    function add(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;

      var original = btn.textContent;
      var addedLabel = btn.getAttribute('data-added-label') || 'Added';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('symk:cart:change', { detail: cart }));
          btn.classList.add('is-added');
          btn.textContent = addedLabel;
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.disabled = false;
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-symk-cart-add]') : null;
      if (!btn) return;
      e.preventDefault();
      add(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["symk-wishlist-store"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SymkWishlist) return;

    var KEY = 'symk:wishlist';

    function read() {
      try {
        var arr = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    }

    function emit(items) {
      document.dispatchEvent(
        new CustomEvent('symk:wishlist:change', { detail: { items: items } })
      );
    }

    function write(items) {
      try {
        localStorage.setItem(KEY, JSON.stringify(items));
      } catch (e) {}
      emit(items);
    }

    function indexOf(items, handle) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].handle === handle) return i;
      }
      return -1;
    }

    var api = {
      key: KEY,
      items: read,
      count: function () {
        return read().length;
      },
      has: function (handle) {
        return indexOf(read(), handle) !== -1;
      },
      add: function (item) {
        if (!item || !item.handle) return;
        var items = read();
        if (indexOf(items, item.handle) === -1) {
          items.push({
            handle: item.handle,
            variantId: item.variantId || null,
            qty: item.qty > 0 ? item.qty : 1
          });
          write(items);
        }
      },
      remove: function (handle) {
        var items = read();
        var i = indexOf(items, handle);
        if (i !== -1) {
          items.splice(i, 1);
          write(items);
        }
      },
      toggle: function (item) {
        if (!item || !item.handle) return false;
        if (api.has(item.handle)) {
          api.remove(item.handle);
          return false;
        }
        api.add(item);
        return true;
      },
      setQty: function (handle, qty) {
        var items = read();
        var i = indexOf(items, handle);
        if (i !== -1) {
          items[i].qty = Math.max(1, parseInt(qty, 10) || 1);
          write(items);
        }
      },
      clear: function () {
        write([]);
      }
    };

    window.SymkWishlist = api;

    // Broadcast initial state so listeners (header count, save buttons) sync.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        emit(read());
      });
    } else {
      emit(read());
    }

    // Keep other open tabs in sync.
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) emit(read());
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
